module.exports = __webpack_public_path__ + "img/ch21.5c04361b.png";